module.exports = __webpack_public_path__ + "static/banner-two-shape9-bfafc8a3d5a5b8951943eea84c77a6a7.png";